import { fallback, http } from 'viem';
import { cookieStorage, createStorage } from 'wagmi';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { bsc } from '@reown/appkit/networks';

export const projectId = String(process.env.NEXT_PUBLIC_REOWN_PROJECT_ID);

export const chain = bsc;

const schema = [
  { url: 'https://bsc-dataseed1.bnbchain.org' },
  { url: 'https://bsc-dataseed1.defibit.io' },
  { url: 'https://bsc-rpc.publicnode.com' },
  { url: 'https://bsc.drpc.org' },
];

export const customRpcUrls: Record<`eip155:${number}`, typeof schema> = {
  [`eip155:${chain.id}`]: schema,
};

export const wagmiAdapter = new WagmiAdapter({
  networks: [chain],
  chains: [chain],
  projectId,
  ssr: true,
  storage: createStorage({ storage: cookieStorage }),
  batch: { multicall: true },
  cacheTime: chain.blockTime / 2,
  transports: { [chain.id]: fallback(schema.map((rpc) => http(rpc.url))) },
});

export const config = wagmiAdapter.wagmiConfig;
